import React from "react";
import NavAndHero from "../components/NavAndHero";
import CallToAction from "../components/CTA";
import Footer from "../components/Footer";
import { ReactComponent as ProductImage } from "../images/undraw_void_wez2.svg"; // Swap as desired

const ProductsPage = () => {
  return (
    <div data-theme="light">
      <NavAndHero />

      {/* Coming Soon Section */}
      <section className="min-h-screen bg-base-200 flex flex-col justify-center items-center text-center px-6 py-24 space-y-8">
        <ProductImage className="w-64 md:w-80 h-auto" />

        <h1 className="text-4xl md:text-5xl font-bold text-base">
          Coming Soon
        </h1>

        <p className="text-lg text-gray-600 max-w-xl">
            Something exciting is on the way. We're building a collection of offerings designed to elevate your experience and bring even more value to your journey with Digiscape.
        </p>

        <p className="text-md text-gray-500">
            Stay tuned — it's going to be worth the wait ⭐️
        </p>
      </section>

      <Footer />
    </div>
  );
};

export default ProductsPage;
